import React from "react";
import { StyledApprovalContainer } from "./styles";
import { APPROVAL_ACTIONS } from "../../utils/constants";
import { Popupmenu } from "../UI/PopupMenu";
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import VerifiedIcon from '@mui/icons-material/Verified';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
const TimesheetApprovalAction = (params) => {
  const { data, value, onMoreAction = () => {} } = params;
  const { projectId, timesheetId, showActionButton } = data;

  const getTooltip = (value) => {
    switch (value) {
      case 'Approved': 
      return (
        <Tooltip title="Approved" placement="top-start" arrow slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -10],
              },
            },
          ],
        },
      }}>
          <IconButton>
            <VerifiedIcon />
          </IconButton>
        </Tooltip>
      );
      case 'Rejected': 
      return (
        <Tooltip title="Rejected" placement="top-start" arrow slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -10],
              },
            },
          ],
        },
      }}>
          <IconButton>
            <UnpublishedIcon />
          </IconButton>
        </Tooltip>
      );
      case 'Pending': 
      return (
        <Tooltip title="Pending" placement="top-start" arrow slotProps={{
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, -10],
                  },
                },
              ],
            },
          }}>
          <IconButton>
            <HourglassBottomIcon />
          </IconButton>
        </Tooltip>
      );
      default:
        return false
    }
  }

  return (
    <StyledApprovalContainer
      className={`${
        showActionButton ? "tma_approval-edit" : "tma_read_action"
      }`}
    >
      <span className={`tma_status tma_status_${value?.toLowerCase()}`}>
        {getTooltip(value)}
      </span>
      {
        <Popupmenu
          id={`tma_${projectId}-approval_btn`}
          onOptionSelect={({ value }) => {
            onMoreAction([timesheetId], value);
          }}
          iconcomponent={BorderColorOutlinedIcon}
          popupOptions={APPROVAL_ACTIONS}
          disabled={!showActionButton}
        />
      }
    </StyledApprovalContainer>
  );
};

export { TimesheetApprovalAction };
